const RANKING = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', tag: '独家', views: '128.6万', hot: true },
  { rank: 2, title: '年度热门综艺录制现场爆发冲突', tag: '综艺', views: '96.3万', hot: true },
  { rank: 3, title: '新晋流量小生恋情疑似曝光', tag: '恋情', views: '85.1万', hot: true },
  { rank: 4, title: '娱乐圈税务风暴多名艺人被约谈', tag: '税务', views: '72.8万', hot: false },
  { rank: 5, title: '网红直播带货翻车现场视频流出', tag: '网红', views: '68.4万', hot: true },
  { rank: 6, title: '知名明星夫妻社交平台互相取关', tag: '婚变', views: '59.2万', hot: false },
  { rank: 7, title: '年度古装巨制开机路透照首曝光', tag: '新剧', views: '51.7万', hot: false },
];

const getRankStyle = (rank: number) => {
  if (rank === 1) return 'bg-accent-500 text-white';
  if (rank === 2) return 'bg-accent-400 text-white';
  if (rank === 3) return 'bg-accent-300 text-white';
  return 'bg-secondary-100 text-secondary-700';
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            实时更新的明星大瓜热度排行榜，看看今天最火的瓜是哪一个
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
            {RANKING.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-primary-50/50 cursor-pointer no-underline ${
                  i < RANKING.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm flex-shrink-0 ${getRankStyle(item.rank)}`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm md:text-base text-foreground-900 font-medium truncate">
                      {item.title}
                    </span>
                    {item.hot && (
                      <span className="flex items-center gap-0.5 text-accent-500 flex-shrink-0">
                        <i className="ri-fire-line text-xs"></i>
                      </span>
                    )}
                  </div>
                </div>
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap flex-shrink-0">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap flex-shrink-0 hidden sm:block">
                  {item.views}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}